/**
 * User types used in the application

 * @readonly
 * @constant
 */

export default {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  USER: 3,
};
